module.exports = __webpack_public_path__ + "img/1.edea59a8.jpg";